import type { AdminRole } from '../constants/roles';

/**
 * 判斷是否為最高權限管理帳號（禁止前台租賃）
 * owner / super_admin：禁止作為前台 customer 下單與編輯 customer profile
 * store_manager / staff / part_time：允許建立前台租賃資料
 */
export function isHighestPrivilegeAdmin(role: string | null | undefined): role is 'owner' | 'super_admin' {
  return role === 'owner' || role === 'super_admin';
}

/**
 * 判斷是否為後台管理帳號（任何在 admin_profiles 中的角色）
 */
export function isAnyAdmin(role: string | null | undefined): boolean {
  const adminRoles: AdminRole[] = ['owner', 'super_admin', 'store_manager', 'staff', 'part_time'];
  return !!role && adminRoles.includes(role as AdminRole);
}

/**
 * 判斷是否為一般員工（非最高權限，但屬於後台帳號）
 */
export function isStaffAccount(role: string | null | undefined): boolean {
  return role === 'store_manager' || role === 'staff' || role === 'part_time';
}